import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Zap } from 'lucide-react';
import { Button } from './ui/button';
import { company } from '../mock';

const navLinks = [
  { name: 'Home', href: '/' },
  { name: 'Products', href: '/products' },
  { name: 'Insights', href: '/insights' },
  { name: 'About', href: '/about' },
  { name: 'Contact', href: '/contact' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <header
      className={`fixed top-[42px] inset-x-0 z-40 transition-all duration-300 ${
        scrolled
          ? 'bg-[#0b0b0d]/85 backdrop-blur-md border-b border-white/5'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          {company.logo ? (
            <img
              src={company.logo}
              alt="Prakash Electrodes"
              className="h-12 w-auto object-contain group-hover:scale-105 transition-transform drop-shadow-lg"
            />
          ) : (
            <div className="h-11 w-11 rounded-md bg-amber-500 flex items-center justify-center shadow-lg shadow-amber-500/25 group-hover:scale-105 transition-transform">
              <Zap className="h-6 w-6 text-[#0b0b0d]" strokeWidth={2.5} />
            </div>
          )}
          <div className="leading-tight">
            <div className="font-display text-white text-lg font-semibold">Prakash Electrodes</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-amber-500/90">Private Limited • Since 1985</div>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((l) => {
            const active = pathname === l.href;
            return (
              <Link
                key={l.href}
                to={l.href}
                className={`relative px-4 py-2 text-sm font-medium transition-colors ${
                  active ? 'text-amber-400' : 'text-white/75 hover:text-white'
                }`}
              >
                {l.name}
                {active && (
                  <span className="absolute left-4 right-4 -bottom-0.5 h-px bg-amber-400" />
                )}
              </Link>
            );
          })}
        </div>

        <div className="hidden md:block">
          <Link to="/contact">
            <Button className="btn-primary bg-amber-500 hover:bg-amber-500 text-[#0b0b0d] font-semibold px-5 rounded-md">
              Get a Quote
            </Button>
          </Link>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="md:hidden text-white p-2"
          aria-label="menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-[#0b0b0d] border-t border-white/5 px-6 py-6 space-y-3">
          {navLinks.map((l) => (
            <Link
              key={l.href}
              to={l.href}
              className={`block text-lg font-medium ${
                pathname === l.href ? 'text-amber-400' : 'text-white/80'
              }`}
            >
              {l.name}
            </Link>
          ))}
          <Link to="/contact">
            <Button className="bg-amber-500 hover:bg-amber-500 text-[#0b0b0d] font-semibold w-full mt-3">
              Get a Quote
            </Button>
          </Link>
        </div>
      )}
    </header>
  );
}
